import Api from "./Api";
import Utils from "../utilities/Utils";
import { ArticleTag } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class ArticleTagsController extends Api {
  static getArticleTags(helpCenterId: string, params: object) {
    return fetch(
      `/api/help_centers/${helpCenterId}/article_tags?${SearchHelper.getQueryString(
        params
      )}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static get(helpCenterId: string, params: any) {
    return fetch(
      `/api/help_centers/${helpCenterId}/article_tags/${
        params.id
      }?${Utils.encodeQueryData(params)}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static create(helpCenterId: string, articleTag: ArticleTag) {
    return fetch(`/api/help_centers/${helpCenterId}/article_tags`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({
        article_tag: articleTag,
      }),
    }).then((res) => res.json());
  }

  static update(helpCenterId: string, articleTag: ArticleTag) {
    return fetch(
      `/api/help_centers/${helpCenterId}/article_tags/${articleTag.id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
        body: JSON.stringify({ article_tag: articleTag }),
      }
    ).then((res) => res.json());
  }

  static delete(helpCenterId: string, id: string) {
    return fetch(`/api/help_centers/${helpCenterId}/article_tags/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(helpCenterId: string, id?: string) {
    const params = { id: id };

    return fetch(
      `/api/help_centers/${helpCenterId}/article_tags/form?${Utils.encodeQueryData(
        params
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
